import { render, staticRenderFns } from "./Zone5Admin.vue?vue&type=template&id=22363131&scoped=true&"
import script from "./Zone5Admin.vue?vue&type=script&lang=js&"
export * from "./Zone5Admin.vue?vue&type=script&lang=js&"
import style0 from "./Zone5Admin.vue?vue&type=style&index=0&id=22363131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22363131",
  null
  
)

export default component.exports